import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { FindingClassType } from '../../types';

export abstract class EasmBulkChangePropertyBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract getTitle(): string;

  public abstract getDescription(findingsClassType: FindingClassType, preSelectedValueLabel: string | null): string;

  public abstract getOptionsLabel(): string;

  public abstract getOptionsPlaceholder(): string;

  public abstract getRequiredOptionErrorMessage(): string;

  public abstract getApplyToArtifactsOptionLabel(): string;

  public abstract changeBulkProperty(
    findingIds: string[],
    value: any,
    updateRelatedArtifacts: boolean,
    note: string
  ): Promise<any>;

  public abstract getSuccessToastMessage(response: any): string;

  public abstract getFailureToastMessage(error: any, value: any): string;
}
